import { useMemo, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useThemeStore } from '@shared/hooks/useThemeStore';
import { buildTheme } from './theme/buildTheme';
import { syncCssVariables } from './theme/syncCssVariables';
import type { BrandingThemeTokens } from '@shared/types';

interface Props {
  brandingTokens?: BrandingThemeTokens;
  children: React.ReactNode;
}

export function ThemeProvider({ brandingTokens, children }: Props) {
  const mode = useThemeStore((s) => s.mode);

  const theme = useMemo(() => buildTheme(mode, brandingTokens), [mode, brandingTokens]);

  useEffect(() => {
    const root = document.documentElement;
    if (mode === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [mode]);

  useEffect(() => {
    syncCssVariables(theme);
  }, [theme]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
